module.exports = __webpack_public_path__ + "media/icons/check@2x-1b132182.png";